import axios from 'axios';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';

const useCreateIdCard = ({ onModalClose }) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(
    async ({idCardData, onSuccessCallback}) => {
      return await axios.post(`/idcards`, idCardData);
    },
    {
      onSuccess: (res, {onSuccessCallback}) => {
        queryClient.invalidateQueries('idCards', { exact: true });
        onSuccessCallback();
        toast.success('Id Card Created', {
          position: toast.POSITION.TOP_LEFT,
        });
        onModalClose();
      },
      onError: (err) => {
        let errorMsg = err?.response?.data?.error || err.message;
        toast.error(`${errorMsg}`, {
          position: toast.POSITION.TOP_LEFT,
        });
      },
    }
  );
  return {
    createIdCard: mutate,
    isLoading,
  };
};

export default useCreateIdCard;
